export const DEFAULT_CELL_LINE_SEPARATOR = '\u001F';
function collapseWhitespace(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
}
export function renderTableToMarkdown(node, h, options = {}) {
    var _a;
    const cellSep = (_a = options.cellLineSeparator) !== null && _a !== void 0 ? _a : DEFAULT_CELL_LINE_SEPARATOR;
    if (!node || !node.content || node.content.length === 0) {
        return '';
    }
    // Build rows: each cell is { text, isHeader }
    const rows = [];
    node.content.forEach(rowNode => {
        const cells = [];
        if (rowNode.content) {
            rowNode.content.forEach(cellNode => {
                let raw = '';
                if (cellNode.content && Array.isArray(cellNode.content) && cellNode.content.length > 1) {
                    // Render each direct child separately and join with separator so we can split again later
                    const parts = cellNode.content.map(child => h.renderChildren(child));
                    raw = parts.join(cellSep);
                }
                else {
                    raw = cellNode.content ? h.renderChildren(cellNode.content) : '';
                }
                const text = collapseWhitespace(raw);
                const isHeader = cellNode.type === 'tableHeader';
                cells.push({ text, isHeader });
            });
        }
        rows.push(cells);
    });
    const columnCount = rows.reduce((max, r) => Math.max(max, r.length), 0);
    if (columnCount === 0) {
        return '';
    }
    // Compute max width for each column
    const colWidths = new Array(columnCount).fill(0);
    rows.forEach(r => {
        var _a;
        for (let i = 0; i < columnCount; i += 1) {
            const cell = ((_a = r[i]) === null || _a === void 0 ? void 0 : _a.text) || '';
            const len = cell.length;
            if (len > colWidths[i]) {
                colWidths[i] = len;
            }
            if (colWidths[i] < 3) {
                colWidths[i] = 3;
            }
        }
    });
    const pad = (s, width) => s + ' '.repeat(Math.max(0, width - s.length));
    const headerRow = rows[0];
    const hasHeader = headerRow.some(c => c.isHeader);
    let out = '\n';
    // Render header: if the document has a header row (tableHeader cells) use it,
    // otherwise emit an empty header row so most Markdown parsers will recognize
    // the table (this makes roundtripping to Markdown -> JSON more reliable).
    const headerTexts = new Array(columnCount)
        .fill(0)
        .map((_, i) => (hasHeader ? (headerRow[i] && headerRow[i].text) || '' : ''));
    out += `| ${headerTexts.map((t, i) => pad(t, colWidths[i])).join(' | ')} |\n`;
    // Separator (use at least 3 dashes per column)
    out += `| ${colWidths.map(w => '-'.repeat(Math.max(3, w))).join(' | ')} |\n`;
    // Body rows: if we had a header, skip the first row; otherwise render all rows
    const body = hasHeader ? rows.slice(1) : rows;
    body.forEach(r => {
        out += `| ${new Array(columnCount)
            .fill(0)
            .map((_, i) => pad((r[i] && r[i].text) || '', colWidths[i]))
            .join(' | ')} |\n`;
    });
    return out;
}
export default renderTableToMarkdown;
